export default {
  AWAITING: 0,
  VERIFYING: 1,
  APPROVED: 2,
  REJECTED: 3,
};
